import React from 'react';
import { useLocation } from 'react-router-dom';

import PageHeader from '../../Components/PageHeader/PageHeader';

const ResearchProjectDetails = (props) => {
    const location = useLocation()
    const { state } = location

    return (
        <>
            <PageHeader
                title="Research"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    { label: 'Research', href: '/research/researchProject' },
                    { label: state?.title }
                ]}
            />

            <div className="container pb-5 pt-5" >
                <h2 className="mb-5">{state?.title}</h2>

                <img
                    src={`https://api.coeupdspadelhi.in/uploads/${state?.image}`}
                    className="card-img-top"
                    alt={state?.title}
                />

                <p className="mt-5">
                    {state?.description}
                </p>

                <div className="row mb-4 mt-5">
                    {
                        state?.gallery?.map((item) => (
                            <div className="col-md-4 mb-3">
                                <div className="card">
                                    <img
                                        src={`https://api.coeupdspadelhi.in/uploads/${item}`}
                                        className="card-img-top"
                                        alt=" "
                                    />
                                </div>
                            </div>
                        ))
                    }
                </div>

            </div>

        </>
    );
};

export default ResearchProjectDetails;